const GOOGLE_MAP_API_URL = (api_key, zipcode = null) => {
  // Replace this with your actual Google Maps API URL construction logic
  return `https://maps.googleapis.com/maps/api/geocode/json?${zipcode? 'address=' + zipcode + '&' : ''}key=${api_key}`
}

export  { GOOGLE_MAP_API_URL }